import { trackingService } from '../tracking.service';

export function useAnalyticsTracker() {
  return {
    eventTrack: trackingService.track.bind(trackingService)
  };
}
